import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonInCircleWithDismiss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22a10 10 0 1 1 9.94-8.89 1.006 1.006 0 0 1-2-.22q.052-.443.06-.89a8 8 0 1 0-14.732 4.322C5.996 14.96 7.577 14 9.4 14H14a1 1 0 0 1 0 2H9.4a2.33 2.33 0 0 0-2.56 2q0 .055-.006.108A8 8 0 0 0 13.78 19.8a1 1 0 1 1 .44 1.95A9.7 9.7 0 0 1 12 22"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.155 12.3a3.43 3.43 0 0 0 2.345.95A3.43 3.43 0 0 0 15.9 10l.1-1.76a3.46 3.46 0 0 0-3.43-3.49h-.14A3.47 3.47 0 0 0 9 8.29L9.1 10a3.43 3.43 0 0 0 1.055 2.3m1.719-5.427a1.5 1.5 0 0 1 .556-.123h.14A1.45 1.45 0 0 1 14 8.18l-.09 1.69a1.41 1.41 0 1 1-2.82 0L11 8.24a1.46 1.46 0 0 1 .874-1.367"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M17 21a1 1 0 0 1-.71-1.71L17.58 18l-1.29-1.29a1.004 1.004 0 1 1 1.42-1.42L19 16.58l1.29-1.29a1.004 1.004 0 1 1 1.42 1.42L20.42 18l1.29 1.29a1.002 1.002 0 0 1-.326 1.636A1 1 0 0 1 21 21a1 1 0 0 1-.71-.29L19 19.42l-1.29 1.29A1 1 0 0 1 17 21"
    />
  </svg>
);
export default SvgPersonInCircleWithDismiss;
